<!--<ng-template #content let-modal>-->
<div class="modal-header">
    <h4 class="modal-title"
        [innerHtml]="('ADD'|translate) + '&nbsp;' + (deviceTypeName|translate) + '&nbsp;'+ ('TO'|translate) + '&nbsp;' + deviceParent.uid"></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close(generateLocationPreference)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="filter-for-list">
    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput [value]="childrenAvailable ? childrenAvailable.filter : null"
               (keyup)="applyFilter($event.target.value)"
               [placeholder]="'SEARCH' | translate">
    </mat-form-field>

    <div id="preferences-cont">
        <div>
            <app-progressbar *ngIf="showSpinnerForChannel"></app-progressbar>
            <mat-radio-group class="channels-cont">
                <mat-radio-button [value]="channel" *ngFor="let channel of  listChannelAvailableByDeviceType"
                                  (click)="setChannel(channel)" matTooltipPosition="right"
                                  [matTooltip]="'CLICK_SELECT_CHANNEL' | translate">
                    Channel {{channel}}
                </mat-radio-button>
            </mat-radio-group>
            <b class="channels-cont no-channel"
               *ngIf=" listChannelAvailableByDeviceType.length === 0"> {{'NO_CHANNEL_AVAILABLE' | translate}}</b>
        </div>
        <app-location-assignment-preferences-toggle
                *ngIf="listChannelAvailableByDeviceType.length !== 0"
                [checked]="generateLocationPreference"
                (change)="generateLocationPreference = $event">
        </app-location-assignment-preferences-toggle>
    </div>

    <br clear="both"/>
</div>

<app-progressbar *ngIf="showSpinner===true"></app-progressbar>

<table mat-table [dataSource]="childrenAvailable" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let children"> {{children.id}}</td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
        <td mat-cell *matCellDef="let children">
            <mat-chip-list>
                <mat-chip style="overflow: initial">
                    {{children.type|translate}}
                </mat-chip>
            </mat-chip-list>
        </td>
    </ng-container>

    <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'UID'|translate}}</th>
        <td mat-cell *matCellDef="let children">
            {{children.uid}}
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="width:16%">{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let children">
            <app-progressbar *ngIf="showSpinnerForChannel"></app-progressbar>
            <mat-icon *ngIf=" listChannelAvailableByDeviceType.length > 0 && !showSpinnerForChannel"
                      style="cursor:pointer;color:green"
                      (click)="add(children.id)" matTooltipPosition="right"
                      [matTooltip]="'CREATE_ICON_TOOLTIP'|translate">check_circle
            </mat-icon>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons [pageSize]="5"></mat-paginator>

<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close(generateLocationPreference)"
            [innerHTML]="'CLOSE' | translate">Close
    </button>
</div>
